module.exports = __webpack_public_path__ + "static/media/pin_darkbleu.d8d2d225.svg";